import { render, staticRenderFns } from "./ModalMarketingConsent.vue?vue&type=template&id=0a1990ed"
import script from "./ModalMarketingConsent.vue?vue&type=script&lang=js"
export * from "./ModalMarketingConsent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports